import ShCard from './src/main.vue'

ShCard.install = Vue => {
  Vue.component(ShCard.name, ShCard)
}

export default ShCard
